// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__iSBnA","container":"Footer_container__oKJhn","iconsContainer":"Footer_iconsContainer__1r5zg","span":"Footer_span__vJ2A9"};